import React, { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import MobileBottomNav from '@/components/layout/MobileBottomNav';
import ChatwootWidget from '@/components/layout/ChatwootWidget';
import PullToRefresh from '@/components/ui/PullToRefresh';
import ValidationGuard from '@/components/auth/ValidationGuard';
import { AnimatePresence, motion } from 'framer-motion';

export default function MainLayout() {
    const { pathname } = useLocation();
    const chatwootVisible = pathname === '/inicio' || pathname === '/en';

    return (
        <AnimatePresence mode="wait">
            <motion.div
                key="main-layout"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="flex flex-col min-h-screen"
            >
                <div id="top" />
                <Suspense fallback={null}>
                    <Navbar />
                </Suspense>

                <main className="flex-1">
                    <ValidationGuard>
                        <PullToRefresh>
                            <Outlet />
                        </PullToRefresh>
                    </ValidationGuard>
                </main>

                <Suspense fallback={null}>
                    <MobileBottomNav />
                </Suspense>

                {/* <ChatwootWidget visible={chatwootVisible} /> */}

                <Footer />
            </motion.div>
        </AnimatePresence>
    );
}
